export default __webpack_public_path__ + "static/media/coinbase.18a5f84b.webp";